const womensLeaguesData = {
  "Super Division": {
    "name": "Super Division",
    "config": {
      "ticketPrice": 20,
      "stadiumCapacity": 5000
    }
  },
  "First Division": {
    "name": "First Division",
    "config": {
      "ticketPrice": 15,
      "stadiumCapacity": 2000
    }
  }
};
export default womensLeaguesData;
